import React from 'react';
import classNames from 'classnames';

import { HomepageFooter, LanguagesAbbr } from '../../../../types/working-model';
// temporarily hardcoded logos
import NowStreamingLogo from '../../../../images/now-streaming-on-brandlive.svg';
import NavItem from '../../../general-ui/nav-item/nav-item';
import { getFooterStylingOverrides } from '../../utils';
import '../../../../scss/live-event/base/modules/marketing-page-footer.scss';
import '../../../../scss/live-event/base/marketing-page/footer.scss';
import { useTranslate } from '../../../../i18n/useTranslationModules';
import { useParams } from 'react-router';
import { ParamsProps } from '../../live-event';


interface FooterProps {
	footer: HomepageFooter;
	template: string;
	previewLanguage?: LanguagesAbbr;
	isLandingPage?: boolean;
}

const Footer: React.FC<FooterProps> = ({ footer, template, previewLanguage }) => {
	const { logo } = footer;
	const {
		backgroundColor,
		backgroundImg,
		mainTextOverrides,
		blLogoColor
	} = getFooterStylingOverrides(footer.styling_overrides);
	const { t } = useTranslate("landing");

	const renderLinks = () => {
		// TODO: marketing page needs to pass header a handleScroll function
		// reference editor-main.tsx for functionality

		// TODO: implement ref forwarding for each module rendered on page
		const overrideColor = mainTextOverrides?.split('-')[0];
		const navItems = footer.navItems?.map((navItem, i) => {
			const override = t(`footer.${navItem.button_name.en}`, '');
			return (
				<NavItem
					key={navItem.button_name.base + i}
					navItem={navItem}
					handleScroll={() => ({})}
					className={classNames(
						"footer-nav-item",
						mainTextOverrides,
						{ [`${overrideColor}-hover`]: mainTextOverrides }
					)}
					previewLanguage={previewLanguage}
					labelOverride={override ? override : undefined}
				/>
			);
		});
		return navItems;
	};

	return (
		<footer className={
			classNames(
				"marketing-page-footer",
				template,
				backgroundColor
			)}
		>
			<div className={classNames("footer-container")} style={backgroundImg}>
				<div className="footer-left">
					<img className="footer-logo" src={logo ? logo : ''} aria-hidden="true" alt="" />
				</div>
				<nav className="footer-nav">
					{/*TODO:  change these to link anchors in the marketing page and will be dynamic*/}
					{renderLinks()}
				</nav>
				<div className="footer-right">
					<div className="footer-author">
						<img src={NowStreamingLogo} className={classNames("bl-logo", blLogoColor)} />
					</div>
				</div>
				{/* remove copyright pending further discussions */}
				{/* <div className="footer-copyright"> */}
				{/* &copy; {new Date().getFullYear()}. {t("footer.Copyright")} Brandlive.com */}
				{/* </div> */}
			</div>
		</footer>
	);
};

export default Footer;
